import axios from 'axios'
import {remoteLogUrl, mainWeb} from '@/config/net'
import {getCookie} from '@/tools/cookie'
import device from '@/tools/device'

const token = getCookie('token') || getCookie('i200_token')
const project = 'MallVue'

const api = axios.create({
  timeout: 10000,
  baseURL: remoteLogUrl,
  headers: {'X-Environment': process.env.NODE_ENV}
})

function _sendLog (url, data) {
  if (process.env.NODE_ENV !== 'production') return

  function asyncSend () {
    api.post(url, {
      project: project,
      platform: device.os,
      userToken: token,
      ...data
    })
  }

  setTimeout(asyncSend)
}

function _logAction (recordId) {
  setTimeout(() => {
    axios.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=${recordId}`, {
      headers: {Cookie: token}
    }).then(res => {
    })
  })
}

function _userAction ({actionType = '', dataObj = {}}) {
  _sendLog('/user-action/record-action', {actionType, dataObj})
}

// 追踪创建订单
function createOrder (dataObj) {
  _userAction({actionType: 'createOrder', dataObj})
}

// 追踪订单失败
function createOrderError (dataObj) {
  _userAction({actionType: 'createOrderError', dataObj})
}

// 追踪PV
function userVisitPath (path = '') {
  // 记录Sass类追踪ID
  if (path.startsWith('/valueAddedService/detail/')) {
    let id = path.match(/(\/valueAddedService\/detail\/)(\d*)/)[2]
    if (!id) return
    let recordId = {
      106: 70, // 微信会员卡对应的手机橱窗
      77: 82, // 丽人版详情页
      68: 83, // 手机数码详情页
      67: 81, // 服装鞋帽详情页
      '-1': 76, // 收款物料详情页
      118: 75, // 移动收款详情页
      105: 72, // 手机橱窗详情页
      82: 80, // 高级版详情页
      136: 151, // 小程序
      137: 153 // 新零售套餐
    }[id]
    if (!recordId) return
    _logAction(recordId)
  } else {
    // 记录路径行追踪ID
    let pathRecord = {
      '/recharge/message': 74, // 短信包详情页
      '/recharge/phone': 73, // 充值中心详情页
      '#/mainview/tab/senior': 80, // 高级版详情页
      '#/mainview/tab/value-added-service': 79, // 增值服务首页
      '#/mainview/tab/hardware-market': 77, // 硬件超市首页
      '#/mainview/tab/all-version': 78, // 所有版本首页
      '/account-statement': 86, // 统计Hybrid-H5项目的对账单
      '/rechargeSaas': 154 // 续费页
    }
    let needRecord = pathRecord[path]
    if (!needRecord) {
      let pathNames = Object.keys(pathRecord)
      for (let key of pathNames) {
        if (path.startsWith(key)) {
          needRecord = pathRecord[key]
          break
        }
      }
    }
    if (!needRecord) return
    _logAction(needRecord)
  }
}

export default {
  createOrder,
  createOrderError,
  userVisitPath
}



// WEBPACK FOOTER //
// ./src/tools/remote-log.js